export const loggedinAccount = {
    getters: {
        get: 'loggedinAccount/get'
    },
    mutations: {
        set: 'loggedinAccount/set',
        reset: 'loggedinAccount/reset'
    },
    actions: {
        set: 'loggedinAccount/set',
        reset: 'loggedinAccount/reset'
    }
};

export const token = {
    getters: {
        get_nontemp: 'token/get_nontemp',
        get_temp: 'token/get_temp'
    },
    mutations: {
        set_nontemp: 'token/set_nontemp',
        set_temp: 'token/set_temp',
        reset: 'token/reset'
    },
    actions: {
        set_nontemp: 'token/set_nontemp',
        set_temp: 'token/set_temp',
        reset: 'token/reset'
    }
};

export const user = {
    getters: {
        get: 'user/get'
    },
    mutations: {
        set: 'user/set',
        reset: 'user/reset',
        hasAccessToMultipleAccounts: 'user/hasAccessToMultipleAccounts'
    },
    actions: {
        set: 'user/set',
        reset: 'user/reset',
        hasAccessToMultipleAccounts: 'user/hasAccessToMultipleAccounts'
    }
};

export const path = {
    getters: {
        get: 'path/get'
    },
    mutations: {
        set: 'path/set',
        reset: 'path/reset',
        clearErrors: 'path/clearErrors'
    },
    actions: {
        set: 'path/set',
        reset: 'path/reset',
        addQueryError: 'path/addQueryError',
        clearErrors: 'path/clearErrors'
    }
};
